import { render, staticRenderFns } from "./UserNotifications.vue?vue&type=template&id=24efba4f&scoped=true&"
import script from "./UserNotifications.vue?vue&type=script&lang=js&"
export * from "./UserNotifications.vue?vue&type=script&lang=js&"
import style0 from "./UserNotifications.vue?vue&type=style&index=0&id=24efba4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24efba4f",
  null
  
)

export default component.exports